// Service Maintenance Steps Module - CSS-only module
import './service-maintenance-steps.scss';

// CSS-only module - no JavaScript functionality needed
const BceServiceMaintenanceSteps = {
	// This module is CSS-only, no initialization required
	// The styles are automatically applied when imported
};

export default BceServiceMaintenanceSteps;
